var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-main" },
    [
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "main-center" },
            [
              _c(
                "v-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: "upgrade:policy:add",
                      expression: "'upgrade:policy:add'",
                    },
                  ],
                  staticClass: "v-icon-add",
                  attrs: { type: "primary", name: "" },
                  on: { click: _vm.showAdd },
                },
                [_vm._v("添加")]
              ),
              _c("v-input", {
                staticClass: "inputsearch",
                attrs: {
                  placeholder: "请输入搜索内容",
                  "suffix-icon": "v-icon-search",
                },
                on: { change: _vm.searchdata },
                model: {
                  value: _vm.searchValue,
                  callback: function ($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "vxe-table",
                {
                  attrs: {
                    border: "",
                    "row-id": "id",
                    data: _vm.table,
                    align: "left",
                    "row-style": _vm.setRowClass,
                  },
                  on: { "cell-click": _vm.cellClickEvent },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "id",
                      "show-overflow": "",
                      "min-width": "50",
                      title: "ID",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "strategy_typeshow",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "策略类型",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "source_ver",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "源版本",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "target_ver",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "目标版本",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "created_at",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "上传时间",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "updated_at",
                      "show-overflow": "",
                      "min-width": "160",
                      title: "更新时间",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "操作", "min-width": "180" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showEdit(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("编辑")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDown(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("下载")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn3",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDel(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn4",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDetails(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("详情")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.total
            ? _c("v-pagination", {
                attrs: {
                  total: _vm.total,
                  name: "page-basic",
                  "is-show-total": "",
                  "is-change-size": "",
                  "is-input-page": "",
                  "current-page": this.currentPage,
                },
                on: {
                  "change-page": _vm.changePage,
                  "change-size": _vm.changeSize,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("UpgradeStrategy", {
        ref: "upgradeStrategy",
        attrs: { showInputDialog: _vm.showAddDialog, UseId: _vm.showID },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.showAddDialog = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.showAddDialog = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _c("Edit", {
        ref: "Edit",
        attrs: { showInputDialog: _vm.showEditDialog, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.showEditDialog = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.showEditDialog = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("Down", {
        ref: "Down",
        attrs: {
          showInputDialog: _vm.Downloading,
          UseId: _vm.showID,
          file_url: _vm.dowmfile_url,
        },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Downloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Downloading = $event
          },
        },
      }),
      _c("Del", {
        ref: "Del",
        attrs: { showInputDialog: _vm.Delloading, UseId: _vm.showID },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Delloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Delloading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
      _c("Details", {
        ref: "Details",
        attrs: { showInputDialog: _vm.Detailsloading, row: _vm.row },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Detailsloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Detailsloading = $event
          },
          getData: function ($event) {
            return _vm.getData()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("div", { staticClass: "main-title" }, [_vm._v("定向升级")]),
      _c("div", { staticClass: "main-title-tips" }, [
        _vm._v("可对不同升级策略信息进行查看和操作"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }